<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <h1>{{ 'billing.exportList.title' | translate }}</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <section class="headerFilter">
      <form *ngIf="orders && !isLoadingFilterForm" [formGroup]="filterForm" (submit)="onFilter()" class="filterForm">

        <mat-form-field>
          <mat-label>Entrer une période</mat-label>
          <mat-date-range-input formGroupName="range" [rangePicker]="picker">
            <input matStartDate formControlName="fromStartDate" placeholder="Du" (focus)="picker.open()">
            <input matEndDate formControlName="toStartDate" placeholder="Au" (focus)="picker.open()">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>

        <button mat-icon-button type="submit" color="primary"
          [disabled]="filterForm.pristine || !filterForm.value.range.fromStartDate || !filterForm.value.range.toStartDate"
          matTooltip="Filtrer">
          <mat-icon>
            search
          </mat-icon>
        </button>

        <button mat-icon-button color="primary" *ngIf="!filterForm.pristine" matTooltip="Effacer les filtres"
          (click)="clearFilters()">
          <mat-icon>
            clear
          </mat-icon>
        </button>
      </form>
      

      <section class="actionsButtons" *ngIf="!isLoading">
        <div class="toggleSubcontractor" *ngIf="canShowSubcontractorToggle">
          <mat-slide-toggle
            [(ngModel)]="useSubcontractorPrices"
            [ngModelOptions]="{standalone: true}"
            color="primary"
          >
            Utiliser les prix sous-traitants
          </mat-slide-toggle>
        </div>
      
        <button mat-raised-button color="primary" class="export-btn" (click)="onExport()"
          [disabled]="isLoading || selection.selected.length === 0" matTooltip="Exporter la sélection">
          <mat-icon aria-label="File">insert_drive_file</mat-icon>
          {{ 'orders.list.export' | translate }}
        </button>

        <button mat-raised-button color="primary" class="export-btn" (click)="onExportAll()" [disabled]="isLoading"
          matTooltip="Exporter tout avec/sans filtre(s)">
          <mat-icon aria-label="File">insert_drive_file</mat-icon>
          {{ 'orders.list.exportAll' | translate }}
        </button>

        <button *ngIf="isAdmin" mat-raised-button color="primary" class="export-btn" (click)="onExportStatistics()"
          [disabled]="isLoading" matTooltip="Exporter les statistiques avec/sans filtre(s)">
          <mat-icon aria-label="File">insert_drive_file</mat-icon>
          {{ 'orders.list.exportStatistics' | translate }}
        </button>

        <button mat-raised-button color="primary" class="export-btn" (click)="onExportPreBilling()"
          [disabled]="isLoading || !isCompleteMonthSelected()" 
          matTooltip="Exporter la pré-facturation avec/sans filtre(s)">
          <mat-icon aria-label="File">receipt</mat-icon>
          <span style=" font-size: 12px; display: flex; flex-direction: column; align-items: center;">
            <span>
              Pré-facturation
            </span>
            <span style="font-size: 10px; font-style: italic;">
              (mois complet uniquement)
            </span>
           </span>
        </button>
      </section>
      <mat-spinner *ngIf="isLoading" [diameter]="35" color="primary" class="spinner"></mat-spinner>
    </section>


    <section class="datatable-container">
      <div class="menuDisplayedColumns">
        <button mat-mini-fab color="primary" matTooltip="Préférences des colonnes" [matMenuTriggerFor]="menu">
          <mat-icon>list</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <div cdkDropList (cdkDropListDropped)="drop($event)">
            <div *ngFor="let displayedColumn of displayedColumnsMenuExportList" cdkDrag>
              <section class="menu-item" (click)="$event.stopPropagation()">
                <ng-container *ngIf="displayedColumn.editable">
                  <mat-checkbox class="example-margin" [checked]="displayedColumn.selected"
                    (change)="onSelectMenu($event,displayedColumn.name)">
                    {{ 'orders.list.' + displayedColumn.name | translate }}
                  </mat-checkbox>
                </ng-container>
              </section>
            </div>
          </div>
        </mat-menu>

        <button class="refreshButton" mat-raised-button color="primary" (click)="getList()">Rafraichir</button>
      </div>

      <table mat-table [dataSource]="dataSource" matSort (matSortChange)="onSortChanged($event)"
        [formGroup]="filterForm">
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef class="checkboxCell">
            <!-- <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()">
            </mat-checkbox> -->
          </th>
          <td mat-cell *matCellDef="let row" class="checkboxCell">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
              [checked]="selection.isSelected(row)">
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="identifier">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              {{ 'orders.list.identifier' | translate}}
              <input class="identifier-filter" (click)="$event.stopPropagation()"
                (keydown.enter)="$event.stopPropagation(); filterEnter($event, 'identifier')" matInput type="number"
                formControlName="identifier" placeholder="Filtre">
            </div>
          </th>
          <td mat-cell *matCellDef="let order"> {{ order.identifier }} </td>
        </ng-container>

        <ng-container matColumnDef="startDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'orders.list.startDate' | translate}}</th>
          <td mat-cell *matCellDef="let order">{{ order.startDate | amDateFormat: 'DD/MM/YYYY HH:mm' }}</td>
        </ng-container>

        <ng-container matColumnDef="urgency">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              {{ 'orders.list.urgency' | translate}}
              <div class="autocompleteFilter">
                <app-autocomplete-filter *ngIf="!isLoadingFilterForm" [valueWanted]="'name'"
                  [control]="filterForm.get('urgency')" [list]="urgencies" (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation(); onFilter()">
                </app-autocomplete-filter>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let order">
            <span *ngIf="order.urgency"> {{ order.urgency.name }} </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="sender">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              {{ 'orders.list.sender' | translate}}
              <div class="autocompleteFilter">
                <app-autocomplete-filter *ngIf="!isLoadingFilterForm" [valueWanted]="'name'"
                  [control]="filterForm.get('sender')" [list]="senders" (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation(); onFilter()">
                </app-autocomplete-filter>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let order">
            <span *ngIf="order.sender.address"> {{ order.sender?.address.name }} </span>
            <span *ngIf="!order.sender.address"> {{ order.sender.otherAddress }} </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="receivers">
          <th mat-header-cell *matHeaderCellDef>
            <div class="cellTh">
              {{ 'orders.list.receiver' | translate}}
              <div class="autocompleteFilter">
                <app-autocomplete-filter *ngIf="!isLoadingFilterForm" [valueWanted]="'name'"
                  [control]="filterForm.get('receiver')" [list]="receivers" (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation(); onFilter()">
                </app-autocomplete-filter>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let order">
            <span *ngIf="order.receivers.length > 1">
              <span *ngIf="order.receivers[order.receivers.length - 1].address"> {{
                order.receivers[order.receivers.length - 1].address.name }} (Multiples)</span>
              <span *ngIf="!order.receivers[order.receivers.length - 1].address"> {{
                order.receivers[order.receivers.length - 1].otherAddress }} (Multiples)</span>
            </span>
            <span *ngIf="order.receivers.length === 1">
              <span *ngIf="order.receivers[0].address"> {{ order.receivers[0].address.name }}</span>
              <span *ngIf="!order.receivers[0].address"> {{ order.receivers[0].otherAddress }}</span>
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="site">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              Donneur d'ordre
              <div class="autocompleteFilter">
                <app-autocomplete-filter *ngIf="!isLoadingFilterForm" [valueWanted]="'name'"
                  [control]="filterForm.get('site')" [list]="sites" (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation(); onFilter()">
                </app-autocomplete-filter>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let order">
            <span *ngIf="order.site"> {{ order.site?.name }} </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              {{ 'orders.list.status' | translate}}
              <mat-select class="status-filter" formControlName="status" (click)="$event.stopPropagation()"
                (selectionChange)="filterEnter($event, 'status')" placeholder="Filtre">
                <mat-option *ngFor="let status of allStatus" [value]="status.value">
                  {{status.name}}
                </mat-option>
              </mat-select>
            </div>
          </th>
          <td mat-cell *matCellDef="let order"> {{ showStatusText(order.status) | translate }} </td>
        </ng-container>

        <ng-container matColumnDef="client">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              {{ 'orders.list.client' | translate}}
              <div class="autocompleteFilter">
                <app-autocomplete-filter *ngIf="!isLoadingFilterForm" [valueWanted]="'name'"
                  [control]="filterForm.get('client')" [list]="clients" (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation(); onFilter()">
                </app-autocomplete-filter>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let order">
            <span *ngIf="order.client"> {{ order.client.name }} </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="createdBy">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              Créé par
              <div class="autocompleteFilter createdBy-filter">
                <app-autocomplete *ngIf="!isLoadingFilterForm" [control]="filterForm.get('createdBy')" [isFilter]="true"
                  [canString]="false" [list]="users" (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation();"
                  (selectedOptionForFilter)="filterEnter($event, 'createdBy')">
                </app-autocomplete>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let order">
            <span *ngIf="order.createdBy">
              {{ order?.createdBy?.username }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="createdOn">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Créé le </th>
          <td mat-cell *matCellDef="let order"> {{ order.createdOn | amDateFormat: 'DD/MM/YYYY HH:mm' }} </td>
        </ng-container>

        <ng-container matColumnDef="driver">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              Chauffeur
              <div class="autocompleteFilter">
                <app-autocomplete-filter *ngIf="!isLoadingFilterForm" [valueWanted]="'username'"
                  [control]="filterForm.get('driver')" [list]="drivers" (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation(); onFilter()">
                </app-autocomplete-filter>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let order">{{ order.driver.username}}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> {{ 'orders.list.actions' | translate }} </th>
          <td mat-cell *matCellDef="let order" class="tdActions">
            <button mat-icon-button class="action-button" color="primary" [disabled]="isLoading"
              matTooltip="Générer article" (click)="generateArticle(order.id)">
              <mat-icon aria-label="Generate">euro</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let mission; columns: displayedColumns;" class="mission" [ngClass]="{
          'disabled': mission.status === 32 || mission.isDeleted,
          'isTreated' : mission.status === 4,
          'inProgress' : mission.status === 128,
          'finished' : mission.status === 16
      }"></tr>
      </table>
    </section>
    <mat-progress-bar *ngIf="isLoading" class="progress-bar" mode="indeterminate" color="primary"></mat-progress-bar>
    <mat-paginator *ngIf="pagination" [pageSize]="pagination.pageSize" [length]="pagination.totalRecords"
      [pageIndex]="pagination.pageNumber - 1" (page)="onPageChanged($event)" showFirstLastButtons></mat-paginator>
  </mat-card-content>
</mat-card>